import { Box } from '@bechtel/gds';
import { concat, get, map } from 'lodash';
import { Suspense, useMemo } from 'react';
import { Navigate, Outlet, useRoutes } from 'react-router-dom';
import { ErrorBoundary, Navbar, NotFound, SuspenseLoader, useAppUser } from '~/components';
import IssueComponents from './issue-components';
import { issueComponentsItem, navbarToolSectionItems, toolsComponents } from './utils';

const ProtectedRoute = ({ children }) => {
  const { userAccount } = useAppUser();
  const tenantConfig = get(userAccount, 'tenantConfig');

  if (!tenantConfig) return null;

  if (
    tenantConfig?.isCableChangeControlUsed ||
    tenantConfig?.isEquipmentChangeControlUsed ||
    tenantConfig?.isJumperChangeControlUsed ||
    tenantConfig?.isRacewayChangeControlUsed
  ) {
    return children;
  }

  return <Navigate to="/" replace />;
};

const ToolsRoutes = ({ routesData }) => {
  const generateRoutes = (data) =>
    map(data, (item) => {
      const path = item.path;
      return { path: `${path}/*`, element: toolsComponents[path] };
    });
  const updatedRoutes = generateRoutes(routesData);
  updatedRoutes.push(
    {
      path: '/issuecomponents',
      element: (
        <ProtectedRoute>
          <IssueComponents />
        </ProtectedRoute>
      ),
    },
    {
      path: '/*',
      element: <NotFound />,
    }
  );
  const routes = useRoutes(updatedRoutes);
  return routes;
};
const Tools = () => {
  const { userAccount } = useAppUser();
  const tenantConfig = get(userAccount, 'tenantConfig');

  const navbarItems = useMemo(() => {
    if (
      tenantConfig?.isCableChangeControlUsed ||
      tenantConfig?.isEquipmentChangeControlUsed ||
      tenantConfig?.isJumperChangeControlUsed ||
      tenantConfig?.isRacewayChangeControlUsed
    ) {
      return concat(navbarToolSectionItems, issueComponentsItem);
    }
    return navbarToolSectionItems;
  }, [tenantConfig]);

  return (
    <Box flexGrow={{ sm: ' 1' }}>
      <Navbar navbarItems={navbarItems} />
      <ErrorBoundary>
        <Suspense fallback={<SuspenseLoader />}>
          <ToolsRoutes routesData={navbarItems} />
        </Suspense>
      </ErrorBoundary>
      <Outlet />
    </Box>
  );
};

export default Tools;
